'use strict';

/** @flow */

import React, {PropTypes} from 'react';
import './styles.scss';

class FormInput extends React.Component {

  // focus() {
  //   this.focusableFormInput.focus();
  // }

  handleChange(event) {
    // console.log("[FormInput] handleChange", this.props);
    this.props.onChange(this.props.name, event.target.value);
  }

  render(): ?ReactElement {
    var errorsDisplay = '',
        errors = this.props.errors,
        formGroupClass = 'form-group ';

    if (errors && errors[this.props.name] && errors[this.props.name].length > 0) {
      errorsDisplay = (
        <small className="help-block">{errors[this.props.name].join(', ')}</small>
      );

      formGroupClass += 'has-error';
    } else if (errors && errors["first_name"]) {
      errorsDisplay = (
        <small className="help-block">First name {errors["first_name"].join(', ')}</small>
      );

      formGroupClass += 'has-error';
    } else if (errors && errors["last_name"]) {
      errorsDisplay = (
        <small className="help-block">Last name {errors["last_name"].join(', ')}</small>
      );

      formGroupClass += 'has-error';
    }

    // let nameErrors = [],
    //     firstNameError = errors["first_name"] || "",
    //     lastNameError = errors["last_name"] || "";
    //
    // nameErrors = firstNameError.length ? nameErrors.push(firstNameError) : nameErrors;
    // nameErrors = lastNameError.length ? nameErrors.push(lastNameError) : nameErrors;
    //
    // console.log("nameErrors", nameErrors);
    // console.log("nameErrors fn", firstNameError);
    // console.log("nameErrors ln", lastNameError);

    // inputType = "email", "tel"

    return (
      <div className={this.props.className}>
        <div className={formGroupClass}>
          <label className="control-label hidden-xs hidden-sm">{this.props.label}</label>
          <input type={this.props.inputType || "text"} value={this.props.value} ref={(ref) => this.focusableFormInput = ref}
            onChange={(e) => this.handleChange(e)} name={this.props.name}
            className="form-control" placeholder={this.props.placeholder} autoFocus={this.props.autoFocus} />
          {errorsDisplay}
        </div>
      </div>
    );
  }
}

FormInput.propTypes = {
  // id: PropTypes.any.isRequired
};

export default FormInput;



/** WEBPACK FOOTER **
 ** ../components/FormInput/index.js
 **/